<template>
  <div class="Tekshiruv">
    <div
      v-for="(itemP, indexTek) in datas.inspection"
      :key="indexTek"
      class="inspec-loop"
    >
      <div>
        <div>
          <PechatLogo />
        </div>
      </div>

      <div class="BayonotChild">
        <div style="width: 100%;">
          <PechatBemorData
            :datas="datas"
            :date="itemP.date_doctor"
            :name="itemP.inspection.name"
            :bolim="itemP.category.name"
            :doctor_name="datas.activeUser"
          />
        </div>
      </div>
      <div
        v-for="item in itemP.reg_ins_file"
        style="width: 100%; text-align: center;"
      >
        <img
          :src="BASE_URL + item.file_name"
          style="width: 600px; height: 600px;"
        />
      </div>
      <div
        class="vueTextEditorT"
        :class="{
          vueTextEditor: itemP.uppercase,
          vueTextEditorUp: itemP.uppercase
        }"
        v-for="itemCh in itemP.registration_inspection_child"
      > 
        <div
          v-for="(itemText, indText) in JSON.parse(itemCh.norm)"
          :key="indText"
          class="text-page"
          :style="indText ? 'padding-top: 20px;' : ''"
        >
          <div :class="{ textEdirorSh: indText, textEdirorShI: !indText }">
            <ckeditor
              v-if="itemP.table_type"
              :style="indText ? 'height: 1100px;' : 'height: 950px;' + 'width: 917px;'"
              v-model="itemText[`${itemText.key}`]"
              :editor="editor"
              :config="editorConfig"
            >
            </ckeditor>
            <vue-editor
              v-else
              :style="indText ? 'height: 1100px;' : 'height: 950px;' + 'width: 917px;'"
              v-model="itemText[`${itemText.key}`]"
              :editor-toolbar="customToolbar"
            />
          </div>
        </div>
      </div>
      <!-- <div v-else>
        <UziExoPechat 
          :statsionar_text="JSON.parse(itemP.registration_inspection_child[0].norm)"
        />
      </div> -->
    </div>
  </div>
</template>

<script>
// import UziExoPechat from "./Components/Tekshiruvlar/UziExoPechat.vue";
import PechatLogo from "./Components/PechatLogo.vue";
import PechatBemorData from "./Components/PechatBemorData.vue";
// import PechatFooter from "./Components/PechatFooter.vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
export default {
  inject: ["BASE_URL"],
  components: {
    PechatLogo,
    PechatBemorData,
    // UziExoPechat
    // PechatFooter
  },
  data() {
    return {
      datas: {},
      customToolbar: [
        // [],
        // ["bold", "italic", "underline"],
        // [{ list: "ordered" }, { list: "bullet" }],
        // ["image", "code-block"]
      ],
      editor: ClassicEditor,
      editorData: "<p>Content of the editor.</p>",
      editorConfig: {
        // The configuration of the editor.
      }
    };
  },
  created() {
    this.datas = JSON.parse(localStorage.getItem("Tekshiruvlar"));
  },
  methods: {},
  mounted() {
    window.print();
    setTimeout(() => {
      localStorage.removeItem("Tekshiruvlar");
      window.close();
      this.$router.push({ path: "/user" });
    }, 3000);
  }
};
</script>

<style scope lang="scss">
.vueTextEditorT .quillWrapper {
  border: none !important;
}
.vueTextEditorT .quillWrapper #quill-container {
  /* font-size: 18px !important; */
  border: none !important;
}
.vueTextEditorT .ql-toolbar {
  display: none;
}
.ql-editor {
  color: #000;
}
.textEdirorSh,
.textEdirorShI {
  .ck-editor__editable {
    border: none;
  }
  .ck-editor__top {
    display: none;
  }
  .ck-editor__editable {
    p {
      line-height: 18pt;
      color: #000;
      font-size: 14pt;
      font-family: "Times New Roman", Times, serif;
      margin: 0px;
    }
    strong {
      font-weight: 700 !important;
    }
    u {
      font-weight: 700 !important;
    }
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      // text-transform: uppercase;
      // line-height: 10px;
      font-family: "Times New Roman", Times, serif !important;
      color: #000;
      // font-size: 20px;
      font-weight: 400;
    }
    h1 {
      font-size: 18pt;
    }
    h2 {
      font-size: 16pt;
      line-height: 18pt;
      margin: 0px;
    }
    h3 {
      font-size: 12pt;
      line-height: 14pt;
      margin: 0px;
    }
    h4 {
      font-size: 10pt;
      line-height: 12pt;
      margin: 0px;
    }
    h5 {
      font-size: 10px;
    }
    h6 {
      font-size: 8px;
    }
  }
}
.textEdirorSh,
.textEdirorShI .ql-editor {
  // text-transform: uppercase;
  font-family: "Times New Roman", Times, serif !important;
  // color: #000;
  p {
    // font-size: 16px;
    // text-transform: uppercase;
  }
  strong {
    font-weight: 700 !important;
  }
  u {
    font-weight: 700 !important;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    // text-transform: uppercase;
    font-family: "Times New Roman", Times, serif !important;
    color: #000;
    // font-size: 20px;
    font-weight: 400;
  }
  h1 {
    font-size: 20px;
  }
  h2 {
    font-size: 18px;
  }
  h3 {
    font-size: 16px;
  }
  h4 {
    font-size: 12px;
  }
  h5 {
    font-size: 10px;
  }
  h6 {
    font-size: 8px;
  }
}
.ck-content .table table td {
  padding: 0px 5px !important;
  text-align: center;
  font-size: 14pt;
}
.ck-content .table table th {
  padding: 0px 5px !important;
  text-align: center !important;
  font-size: 14pt;
}
.vueTextEditorUp .ql-editor {
  text-transform: uppercase;
  font-family: "Times New Roman", Times, serif !important;
  // color: red;
  p {
    // // font-size: 16px;
    // text-transform: uppercase;
  }
  strong {
    font-weight: 700 !important;
  }
  u {
    font-weight: 700 !important;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    text-transform: uppercase;
    font-family: "Times New Roman", Times, serif !important;
    color: #000;
    // font-size: 20px;
    font-weight: 400;
  }
  h1 {
    font-size: 20px;
  }
  h2 {
    font-size: 18px;
  }
  h3 {
    font-size: 16px;
  }
  h4 {
    font-size: 12px;
  }
  h5 {
    font-size: 10px;
  }
  h6 {
    font-size: 8px;
  }
}
.vueTextEditor .ql-editor {
  // text-transform: uppercase;
  font-family: "Times New Roman", Times, serif !important;
  // color: #000;
  p {
    // font-size: 16px;
    // text-transform: uppercase;
  }
  strong {
    font-weight: 700 !important;
  }
  u {
    font-weight: 700 !important;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    // text-transform: uppercase;
    font-family: "Times New Roman", Times, serif !important;
    color: #000;
    // font-size: 20px;
    font-weight: 400;
  }
  h1 {
    font-size: 20px;
  }
  h2 {
    font-size: 18px;
  }
  h3 {
    font-size: 16px;
  }
  h4 {
    font-size: 12px;
  }
  h5 {
    font-size: 10px;
  }
  h6 {
    font-size: 8px;
  }
}

.bg-image {
  /* width: 100%; */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 100%;
  // border: 1px solid red;
  position: absolute;
  /* background-size: contain; */
}
.textEdirorSh {
  margin-top: 20px;
  /* padding-top: 40px; */
  /* padding: 10px; */
  // page-break-inside: auto;
  border: 1px solid #000;
}
.textEdirorShI {
  // page-break-inside: auto;
  /* padding-top: 40px; */
  /* padding: 10px; */
  border: 1px solid #000;
}
.Tekshiruv {
  /* padding: 40px; */
  width: 100%;
  /* background-size: cover; */
  /* border: 5px double #000; */
  /* margin: 10px; */
  /* display: flex;
  flex-wrap: wrap; */
}
.BayonotChild {
  display: flex;
  margin-top: 20px;
  /* border: none !important; */
}
.inspec-loop {
  page-break-after: auto;
  list-style: none;
  width: 917px;
  margin: 0px auto;
  padding-top: 20px;
}
.inpec-name-style {
  font-size: 20px;
  font-weight: 700;
  color: #000;
  text-align: center;
}
.text-page {
  page-break-after: avoid;
  list-style: none;
  position: relative;
}
</style>
